import { addJPushNotificationListener } from '@/lib/jpush'
import { useEffect } from 'react'

// A component to listen to JPush notifications
// for both notificationArrived and notificationOpened events
// it will be used to update the badge number
// currently not used for doing anything
// because badge number is not synced across backend, jpush and mobile app
export default function JPushNotificationListener() {
  useEffect(() => {
    const cleanup = addJPushNotificationListener(notification => {
      console.log('[JPushNotificationListener] 收到通知:', notification)
    })
    return cleanup
  }, [])

  return null
}
